import { AutofillProfile } from './autofill-profile';
import { AutofillRule } from './autofill-rule';
import { AutofillOption } from './autofill-option';

export class AutofillConfig {

    constructor(
        public profiles: AutofillProfile[],
        public rules: AutofillRule[],
        public options: AutofillOption[]
    ){}
}
